import { CheckListItem } from '../elements/check-list-item.element';
import { Icon } from 'react-native-elements/dist/icons/Icon';
import { LinearGradient } from 'expo-linear-gradient';
import PropTypes from 'prop-types';
import React from 'react';
import { Text } from 'react-native-elements';
import { View, TouchableOpacity } from 'react-native';
import i18n from 'i18n-js';
import { isWeb } from '../../utils/platform.utils';
import theme from '../theme';

export const ProductTile = ({ product, selected, onSelect, onSelectedTemplate }) => {
    return (
        <TouchableOpacity
            onPress={() => { onSelect(product.id), onSelectedTemplate(product.template.account_type) }}
            activeOpacity={0.5}
            style={!isWeb() ? { ...theme.shadows.lightBlue } : null}
        >
            <LinearGradient
                {...theme.gradients.lightBlue}
                style={{
                    justifyContent: 'center',
                    borderWidth: 2,
                    boxShadow: selected
                        ? '0px 6px 6px -3px rgba(0, 0, 0, 0.2), 0px 10px 14px 1px rgba(0, 0, 0, 0.14), 0px 4px 18px 3px rgba(0, 0, 0, 0.12)'
                        : null,
                    borderColor: selected
                        ? theme.colors.phthaloBlue
                        : 'rgba(0,0,0,0.2)',
                    backgroundColor: '#FFFFFF',
                    marginBottom: 25,
                    borderRadius: 10,
                    padding: 16,
                }}
            >
                <View
                    style={{
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                >
                    <Text
                        style={{
                            fontSize: 20,
                            flex: isWeb() ? 1 : 0.8,
                            fontFamily: 'DMSans_400Regular',
                        }}
                    >
                        {product.name}
                    </Text>
                    {selected && (
                        <Icon
                            name="checkmark-circle"
                            type="ionicon"
                            size={22}
                            color={theme.colors.phthaloBlue}
                        />
                    )}
                </View>
                <Text
                    style={{
                        fontSize: 12,
                        marginTop: 16,
                        marginBottom: 10,
                        ...theme.typography.mediumFontWeight,
                    }}
                >
                    {product.description}
                </Text>

                <CheckListItem
                    size={12}
                    label={i18n.t('pages.accountSelection.template.spec1')}
                    designIcon={require('../.././../../assets/images/send.png')}
                />
                <CheckListItem
                    size={12}
                    label={i18n.t('pages.accountSelection.template.spec2')}
                    designIcon={require('../.././../../assets/images/monetizationOn.png')}
                />
                <CheckListItem
                    size={12}
                    label={i18n.t('pages.accountSelection.template.spec3', {
                        limit: Object.prototype.hasOwnProperty.call(
                            product.template,
                            'overdraft_limit'
                        )
                            ? product.template.overdraft_limit
                            : 0,
                    })}
                    designIcon={require('../.././../../assets/images/freeBreakfast.png')}
                />
            </LinearGradient>
        </TouchableOpacity>
    );
};

ProductTile.propTypes = {
    product: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        description: PropTypes.string,
        template: PropTypes.shape({
            account_type: PropTypes.string,
            overdraft_limit: PropTypes.number,
        }).isRequired,
    }),
    selected: PropTypes.bool,
    onSelect: PropTypes.func.isRequired,
};
